export function extractPureCss(input: string): string {
  // Remove any number of <style ...>...</style> blocks while keeping their inner CSS
  // Handles attributes, newlines, multiple blocks, and mixed case.
  const blocks: string[] = []
  const re = /<style[^>]*>([\s\S]*?)<\/style>/gi
  let m: RegExpExecArray | null
  while ((m = re.exec(input)) !== null) blocks.push(m[1])

  if (blocks.length) {
    return blocks.join('\n').trim()
  }

  // No <style> tags — return as-is
  return input.trim()
}
